import React, { useEffect, useState } from 'react'

export default function ScrollBtn() {
    const [scrollClass , setScrollClass] = useState("")
    const handleScrollBtn = () => {
        window.scrollTo({top:0,behavior:"smooth"});
    }
    const listenToScroll = () => {
        if(window.pageYOffset>400){
         setScrollClass("activeScroll")
        }
        else{
            setScrollClass("");
        }
    }
    useEffect(() => {
         window.addEventListener("scroll" , listenToScroll);
         return () => {
            window.removeEventListener("scroll" , listenToScroll);
         }
    },[])
  return (
    <>
      <div className={`scrollbtn ${scrollClass}`} onClick={handleScrollBtn}>
      <i class="fa-light fa-chevron-up"></i>
      </div>
    </>
  )
}
